import { render } from "./history.vue?vue&type=template&id=bfcfe346"
import script from "./history.vue?vue&type=script&lang=js"
export * from "./history.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\zhuxu\\source\\repos\\innosource\\site\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__